import { DateTime } from "luxon";

// The server sends plain "YYYY-MM-DD" club dates; read them as calendar days,
// never through the browser's zone.
const day = (iso) => DateTime.fromISO(iso, { zone: "utc" });

export const formatContinuationDay = (iso) => (iso ? day(iso).toFormat("ccc d LLL") : "");
export const formatContinuationShort = (iso) => (iso ? day(iso).toFormat("d LLL") : "");

const UNIT_BY_CATEGORY = {
  "category-service-private": { one: "lesson", many: "lessons" },
  "category-service-class": { one: "class", many: "classes" },
  "category-service-court": { one: "session", many: "sessions" }
};

export const continuationUnit = (categoryType) => UNIT_BY_CATEGORY[categoryType] || { one: "session", many: "sessions" };

// What Plans says about a series the client can continue. A 45-minute and a
// 60-minute series of the same lesson are separate, so the length is named.
export function plansContinuationCopy(series) {
  const until = formatContinuationDay(series.lastSessionDate);
  const length = series.sessionDuration && series.linkedCategoryType !== "category-service-class" ? series.sessionDuration : null;
  // Named by what the client bought, so two series read apart at a glance.
  const title = series.linkedServiceName
    ? `Your ${series.linkedServiceName} package${length ? ` (${length} min)` : ""} is booked until ${until}`
    : `Your ${length ? `${length}-min ` : ""}${continuationUnit(series.linkedCategoryType).many} are booked until ${until}`;
  return {
    title,
    subtitle: `Buy your next pack to carry on from ${formatContinuationDay(series.continueFrom)}.`
  };
}

// What the picker says about a series it is continuing. The first session may
// sit anywhere up to the reach date — the club's window, measured from where
// the current pack ends — so that date is the one stated, not a bare "30 days".
export function pickerContinuationCopy(continuation, categoryType) {
  if (!continuation) return null;
  const unit = continuationUnit(categoryType);
  return {
    title: `Your current ${unit.many} are booked until ${formatContinuationDay(continuation.lastSessionDate)}`,
    subtitle: `This pack can carry on from ${formatContinuationDay(continuation.continueFrom)} — start it any day up to ${formatContinuationDay(continuation.reachDate)}.`,
    actionLabel: `Go to ${formatContinuationShort(continuation.continueFrom)}`
  };
}
